module.exports = __webpack_public_path__ + "img/pasture_brachiaria_high.f5c3624a.webp";